// extracted by mini-css-extract-plugin
export var buttonWrapper = "advantages-dr-module--button-wrapper--33b33";
export var homeAdvantages = "advantages-dr-module--home-advantages--ba1b3";
export var underscore = "advantages-dr-module--underscore--ed92d";